import { diasUteis, parseNumero } from "../calculos";
import { F } from "../gerencialFields";
import { startOfDay, toDate } from "../status";
import {
  ETAPA_LABELS,
  ORDEM_ETAPAS,
  entradaEtapa,
  getEtapaAtual,
} from "./etapas";

function emptyBucket(etapa) {
  return {
    etapa,
    label: ETAPA_LABELS[etapa],
    count: 0,
    valorRS: 0,
    complexidadeTotal: 0,
    idades: [],
  };
}

export function calcularWIP(ambientes, hoje = new Date()) {
  const today = startOfDay(hoje);
  const buckets = Object.fromEntries(
    ORDEM_ETAPAS.map((etapa) => [etapa, emptyBucket(etapa)])
  );

  const lista = Array.isArray(ambientes) ? ambientes : [];

  for (const amb of lista) {
    const etapa = getEtapaAtual(amb);
    if (!etapa) continue;
    const bucket = buckets[etapa];
    bucket.count++;
    bucket.valorRS += parseNumero(amb?.[F.VALOR_DO_AMBIENTE]) || 0;
    bucket.complexidadeTotal += parseNumero(amb?.[F.COMPLEXIDADE_TOTAL]) || 0;

    const entrada =
      entradaEtapa(etapa, amb) || toDate(amb?.[F.APROVACAO_DO_EXECUTIVO]);
    if (entrada && today) {
      const idade = diasUteis(entrada, today);
      if (idade != null && idade >= 0) bucket.idades.push(idade);
    }
  }

  return ORDEM_ETAPAS.map((etapa) => {
    const bucket = buckets[etapa];
    const idadeMedia = bucket.idades.length
      ? bucket.idades.reduce((sum, n) => sum + n, 0) / bucket.idades.length
      : null;
    const idadeMax = bucket.idades.length ? Math.max(...bucket.idades) : null;
    return {
      etapa: bucket.etapa,
      label: bucket.label,
      count: bucket.count,
      valorRS: bucket.valorRS,
      complexidadeTotal: bucket.complexidadeTotal,
      idadeMedia,
      idadeMax,
    };
  });
}

export function totalWIP(wip) {
  return wip.reduce(
    (acc, bucket) => ({
      count: acc.count + bucket.count,
      valorRS: acc.valorRS + bucket.valorRS,
      complexidadeTotal: acc.complexidadeTotal + bucket.complexidadeTotal,
    }),
    { count: 0, valorRS: 0, complexidadeTotal: 0 }
  );
}
